module.exports = __webpack_public_path__ + "static/engagement-6171bd0b892cce2f8bf733ee97d850f4.svg";